import { IonButtons, IonCard, IonCardContent, IonCardHeader, IonCardSubtitle, IonCardTitle, IonCol, IonContent, IonFooter, IonHeader, IonIcon, IonItem, IonMenuButton, IonPage, IonRow, IonTitle, IonToolbar } from '@ionic/react';
import { url } from 'inspector';
import React from 'react';
import { useHistory } from 'react-router';
import { Link } from 'react-router-dom';
import styled from "styled-components";
import LogoutPage from "../pages/Logout";

  const DashboardPage: React.FC = () => {
  const history = useHistory();
    const gotoUpcomingSchedule = () => {
      const token = localStorage.getItem('authToken');
      if(token) {
        console.log('====================================');
        console.log(token);
        console.log('====================================');
        history.push({ 
          pathname: '/upcoming-schedule',
          search: 'selection=inspectionschedule'
         });
      }
    }

    const gotoserviceProgramSchedule = () => {
      const token = localStorage.getItem('authToken');
      if(token) {
        history.push({ 
          pathname: '/upcoming-schedule',
          search: 'selection=serviceprogramschedule'
         });
      }
    }

    const gotoserviceProgramTechnicalOnboardingSchedule = () => {
      const token = localStorage.getItem('authToken');
      if(token) {
        history.push({ 
          pathname: '/upcoming-schedule',
          search: 'selection=serviceprogramtechnicalonboardingschedule'
         });
      }
    }

    const gotopumpOutSchedule = () => {
      const token = localStorage.getItem('authToken');
      if(token) {
        history.push({ 
          pathname: '/upcoming-schedule',
          search: 'selection=pumpoutschedule'
         });
      }
    }

    return (
      <DashPage>
      <IonPage>
      <IonHeader>
        <IonToolbar>
         
         
          <IonRow>
          <IonCol className="ion-align-self-center" style={{textAlign : "center"}}  >
            <img src="assets/logo001.png" width="30%"/>
          </IonCol>

            <LogoutPage/>

          </IonRow>
        </IonToolbar>
        <IonToolbar color="secondary">
    
        <IonTitle>Powered By:<span><b>Septic Smart</b></span></IonTitle>
        
      </IonToolbar>
      </IonHeader>
      
       <IonContent fullscreen >
        <div className="mainDiv-bg">
        <IonRow className="ion-align-items-center ion-justify-content-center">
            <IonCol className="ion-align-items-center ion-justify-content-center" size="3" style={{ margin: '10px' }}  onClick={gotoserviceProgramSchedule}>
            <IonCard className="card-bgColor">
            <img src="assets/Septic Maintenance.png" className="card_img"   />
            <p className="card-txt">MAINTANANCE</p>
            </IonCard>
            </IonCol>
            <IonCol className="ion-align-items-center ion-justify-content-center" size="3" style={{ margin: '10px' }} onClick={gotoserviceProgramTechnicalOnboardingSchedule}>
            <IonCard className="card-bgColor">
            <img src="assets/Site Survey.png" className="card_img"   />
            <p className="card-txt">SITE SURVEY</p>
            </IonCard>
            </IonCol>
            <IonCol className="ion-align-items-center ion-justify-content-center" size="3" style={{ margin: '10px' }} onClick={gotopumpOutSchedule}>
            <IonCard className="card-bgColor">
            <img src="assets/Septic Pumpouts.png" className="card_img"     />
            <p className="card-txt">PUMPOUTS</p>
            </IonCard>
            </IonCol>
          </IonRow>

          <IonRow className="ion-align-items-center ion-justify-content-center">
            <IonCol className="ion-align-items-center ion-justify-content-center" size="3" style={{ margin: '10px' }}  onClick={gotoUpcomingSchedule}>
            <IonCard className="card-bgColor">
            <img src="assets/Septic Inspection.png"  className="card_img"  />
            <p className="card-txt">INSPECTIONS</p>
            </IonCard>
            </IonCol>
            <IonCol className="ion-align-items-center ion-justify-content-center" size="3" style={{ margin: '10px' }}>
            <IonCard className="card-bgColor">
            <img src="assets/Septic Engineering (1).png" className="card_img"/>
            <p className="card-txt">ENGINEERING</p>
            </IonCard>
            </IonCol>
            <IonCol className="ion-align-items-center ion-justify-content-center" size="3" style={{ margin: '10px' }}>
            <IonCard className="card-bgColor">
            <img src="assets/Septic Installations.png"  className="card_img" />
            <p className="card-txt">INSTALLATIONS</p>
            </IonCard>
            </IonCol>
            </IonRow>

            <IonRow className="ion-align-items-center ion-justify-content-center">
            <IonCol className="ion-align-items-center ion-justify-content-center" size="3" style={{ margin: '10px' }}>
            <IonCard className="card-bgColor">
            <img src="assets/Septic Repairs.png" className="card_img"    />
            <p className="card-txt">REPAIRS</p>
            </IonCard>
            </IonCol>
          </IonRow>
        </div>
        <div className="secDiv_mar">
        <IonRow>
          <IonCol className="ion-align-self-center" style={{textAlign : "center"}}  >
         
            <img src="assets/septic-smart.png" width="40%"/>
          </IonCol>
          </IonRow>
        </div>
         
      

      
 </IonContent>
         <div>
            <IonFooter>
              <IonToolbar color="secondary">
                 <IonTitle>Version:<span><b>4.14.231</b></span></IonTitle>
              </IonToolbar>
            </IonFooter>
          </div>
   

    </IonPage>
    </DashPage>
  );
};
const DashPage = styled(IonPage)`
.mainDiv-bg{
  background-color: #cef2d0;
}
.secDiv_mar{
  margin-top: 6%;
}
.card-bgColor{
  background-color: #ffffff;
  border-radius: 0;
}
.card-txt{
  display: flex;
  justify-content: center;
  margin-top: 0;
  color : #006884
}
.card_img{
  margin-left: 14%;
  width: 70%;
  margin-top: 20%;
}
}
`;
export default DashboardPage;
